import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import Loading from '../general/Loading';
import { FaLink } from "react-icons/fa";
import '../css/Admin/SubscriptionPlan.css';


const EduTopics = () => {
  const [isEditMode, setIsEditMode] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [topics, setTopics] = useState([]);
    const [selectedTopic, setSelectedTopic] = useState(null);
    const [showDelete, setShowDelete] = useState(false);
  
    const [formData, setFormData] = useState({
      topic: '',
      image: null,
      edu_link: '',
      description: '',
    });
  

  useEffect(() => {
    fetchTopics();
  }, []);
  

  const fetchTopics = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.tradeintell.com/get-edu-topics');
      if (response.ok) {
        const data = await response.json();
        setTopics(data);
      } else {
        console.error('Failed to fetch topics');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

const handleChange = (e) => {
  const { name, value, files } = e.target;

  if (name === "image") {
    const file = files[0];

    if (!file) return;

    const maxSize = 1024 * 1024; // 1MB in bytes

    if (file.size > maxSize) {
      toast.error("Image size must be less than 1MB.");
      e.target.value = null;
      return;
    }

    setFormData({
      ...formData,
      image: file,
    });

  } else {
    setFormData({
      ...formData,
      [name]: value,
    });
  }
};


    const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.edu_link || !formData.topic) {
    toast.error('Please fill all required fields.');
    return;
  }
  console.log(formData.image);

  try {
    setLoading(true);

    const apiUrl = isEditMode
      ? `https://api.tradeintell.com/edit-topic/${selectedTopic.id}`
      : 'https://api.tradeintell.com/create-topic';

    const formPayload = new FormData();
    formPayload.append("topic", formData.topic);
    formPayload.append("edu_link", formData.edu_link);
    formPayload.append("description", formData.description);

    if (formData.image) {
      formPayload.append("image", formData.image);
    }

    const response = await fetch(apiUrl, {
      method: isEditMode ? 'PUT' : 'POST',
      body: formPayload,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Something went wrong');
    }

    toast.success(isEditMode ? 'Educational Topic Updated.' : 'New Educational Topic Added.');

    setShowForm(false);
    setIsEditMode(false);
    setSelectedTopic(null);
    setFormData({
      topic: '',
      image: null,
      edu_link: '',
      description: '',
    });

    fetchTopics();

  } catch (error) {
    toast.error(error.message || 'Something went wrong. Try again.');
  } finally {
    setLoading(false);
  }
};

  
    const handleManage = (plan) => {
      setShowForm(true);
      setIsEditMode(true);
      setSelectedTopic(plan);
      setFormData({
        topic: plan.topic,
        edu_link: plan.edu_link,
        description: plan.description,
  image: null,        });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };
  

const formatDate = (timestamp) => {
  const date = new Date(timestamp);
  const options = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };
  return date.toLocaleString('en-US', options);
};


const handleRemove = async (tId) => {
  try {
    const response = await fetch(`https://api.tradeintell.com/remove-topic/${tId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
        toast.success('Topic Removed Successfully.');
        setShowDelete(false);
        setSelectedTopic('');
        fetchTopics();


  } catch (error) {
    console.error('Failed to remove item:', error);
  }
};


  return (
    <>
          <section className='my-4'>
        <div className='px-4'>
          <p className='page-heading'>Educational Links</p>
          <p className='para-text text-muted'>Add Topics & Links to your content for Educational Purpose only.</p>

          {!isEditMode && (
            <button className='about-btn mb-3' onClick={() => setShowForm(!showForm)}>
              {showForm ? 'CANCEL' : 'CREATE +'}
            </button>
          )}


          <div className="row mt-3">

                      {showForm && (
              <div className="col-lg-6 col-md-6 col-12 my-2">
                <div className="plan-card p-3">
                  <p className="page-heading text-light">{isEditMode ? 'Edit Edu Link' : 'Create New Edu Link'}
                  </p>
{isEditMode && selectedTopic.image != null && (
  <div className="d-flex flex-wrap gap-2 mt-2">
      <img
        src={`https://api.tradeintell.com/uploads/${selectedTopic.image}`}
        alt="Insight"
        style={{
          width: 60,
          height: 60,
          objectFit: 'cover',
          borderRadius: 5
        }}
        className="cursor-pointer"
        onClick={() =>
          window.open(
            `https://api.tradeintell.com/uploads/${selectedTopic.image}`,
            '_blank'
          )
        }
      />
  
  </div>
)}
                  <form onSubmit={handleSubmit} className='mt-3'>

                    
                    <input
                      type="text"
                      name="topic"
                      placeholder="Topic Name*"
                      value={formData.topic}
                      onChange={handleChange}
                      className="contact-control bg-white"
required
                    />
                    <input
  type="file"
  name="image"
  accept="image/*"
  onChange={handleChange}
  className="contact-control bg-white mt-2"
/>
                    <input
                      type="text"
                      name="edu_link"
                      placeholder="Educational Link*"
                      value={formData.edu_link}
                      onChange={handleChange}
                      className="contact-control bg-white"
                      required
                    />
                    <textarea
                      name="description"
                      placeholder="Topic Details (max 25 words)"
                      value={formData.description}
                      onChange={handleChange}
                      className="contact-control bg-white"
                      rows="3"
                    />

<div className='d-flex'>
                    <button
                      type="submit"
                      className="header-btn py-2 w-100 mt-3"
                      disabled={loading}
                    >
                      {loading ? 'Saving...' : isEditMode ? 'Update Edu Link' : 'Save'}
                    </button>
                    {isEditMode &&
                                        <button
                      className="header-btn py-2 w-100 mt-3 bg-danger ms-3"
                      onClick={() => {
                        setShowForm(false);
                              setIsEditMode(false);
      setSelectedTopic('');
      setFormData({
        topic: '',
        edu_link: '',
        description: '',
      });
                      }}
                    >Cancel</button>
                    }
                    </div>
                    </form>

                  </div>
                  </div>)}

            {topics.length > 0 ? (
              topics.map((el) => (
                <div className="col-lg-4 col-md-6 col-12 my-2" key={el.id}>
                  <div className="plan-card p-3">
                    <p className='page-heading text-light'>{el.topic} <FaLink className='ms-3 cursor-pointer' onClick={() => window.open(`${el.edu_link}`, '_blank')} /> </p>
                    <p className='para-text py-2 fw-bold'>Added On: {formatDate(el.posted_on)}</p>

                    <div className='d-flex flex-wrap'>
                    {el.image != null &&
                    <img src={`https://api.tradeintell.com/uploads/${el.image}`} className='img-fluid rounded me-2' style={{height: '7em'}} />}
                    <p className='para-text fw-semibold'>{el.description}<br />{el.edu_link}</p></div>

<div className='d-flex mt-3'>
                    <button className='header-btn w-100 py-2' onClick={() => handleManage(el)}>
                      Manage
                    </button>               
                    
                    <button className='header-btn w-100 py-2 ms-3' onClick={() => {setShowDelete(true); setSelectedTopic(el) }}>
                      Remove
                    </button>
                  </div>
{/* flex ends */}

                  </div>
                </div>
              ))
            ) : (
              <p>No Plans Created yet.</p>
            )}


</div>
{/* row ends */}


</div>
</section>


{showDelete && (
  <>
<section className='dialog-outer'>
<div className='dialog-inner'>

<p className='page-heading'>Delete Educational Link for "{selectedTopic.topic}" Topic.</p>

<div className='d-flex justify-content-center mt-4'>
                    <button className='header-btn py-2' onClick={() => handleRemove(selectedTopic.id)}>
                      Confirm
                    </button>               
                    
                    <button className='header-btn py-2 ms-3 bg-danger' onClick={() => {setShowDelete(false); setSelectedTopic('') }}>
                      Cancel
                    </button>
                  </div>
{/* flex ends */}

</div>
</section>
  </>
)}

      {loading && <Loading setLoading={setLoading} />}

    </>
  )
}

export default EduTopics